import React from 'react';
import {
	Wrapper, Text,
} from './sellingFastStyles';
import loadable from '@loadable/component';
const iconDims = { width: 42, height: 31 };
const SellingFastIcon = loadable(() => import('./SellingFastIcon'), {
	fallback: <div style={{ ...iconDims, marginRight: 5 }} />
});

const SellingFast = () => {
	return (
		<Wrapper>
			<SellingFastIcon {...iconDims} />
			<Text><span>Selling Fast!</span> - Only a few boxes left. Buy soon while supplies last.</Text>
		</Wrapper>
	);
};

export default SellingFast;
